import { type FunctionComponent } from "react";

import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

import { FacebookUrl, InstagramUrl, LinkedinUrl, TwitterUrl, YoutubeUrl } from "./consts";
import { SocialMedia as SocialMediaEnum } from "./enums";
import FacebookIcon from "./icon-facebook.svg";
import InstagramIcon from "./icon-instagram.svg";
import LinkedinIcon from "./icon-linkedin.svg";
import TwitterIcon from "./icon-twitter.svg";
import YoutubeIcon from "./icon-youtube.svg";
import { Container, IconContainer } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const HomeFooterSocialMedia: FunctionComponent<Props> = ({ className, onClick }) => {
  const socialMediaMap = {
    [SocialMediaEnum.Facebook]: {
      icon: FacebookIcon,
      url: FacebookUrl,
    },
    [SocialMediaEnum.Twitter]: {
      icon: TwitterIcon,
      url: TwitterUrl,
    },
    [SocialMediaEnum.Youtube]: {
      icon: YoutubeIcon,
      url: YoutubeUrl,
    },
    [SocialMediaEnum.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl,
    },
    [SocialMediaEnum.Linkedin]: {
      icon: LinkedinIcon,
      url: LinkedinUrl,
    },
  };

  const renderIcon = (media: SocialMediaEnum) => {
    const { icon: Component, url } = socialMediaMap[media];

    return (
      <IconContainer key={media}>
        <a
          href={url}
          rel="noopener noreferrer"
          target="_blank"
          title="Follow SCMP"
          onClick={() => {
            onClick(url);
            sendGA4Tracking({
              action: "click",
              category: "footer",
              customized_parameters: {
                link_name: media,
                social_platform: media,
              },
              subcategory: "",
            });
          }}
        >
          <Component />
        </a>
      </IconContainer>
    );
  };

  return (
    <Container className={className}>
      {[
        SocialMediaEnum.Facebook,
        SocialMediaEnum.Twitter,
        SocialMediaEnum.Youtube,
        SocialMediaEnum.Instagram,
        SocialMediaEnum.Linkedin,
      ].map(media => renderIcon(media))}
    </Container>
  );
};

HomeFooterSocialMedia.displayName = "HomeFooterSocialMedia";
